import { type RouteObject } from 'react-router';

import { metadataRoute, pushRoute } from '@@components/Page/detailViewRoutes';
import { ErrorPage } from '@@containers/App/ErrorPage';

export const routes: RouteObject[] = [
    {
        index: true,
        lazy: async () => {
            const { TickerList } = await import('@@routes/ticker/TickerList');

            return { Component: TickerList };
        },
    },
    {
        path: 'new',
        lazy: async () => {
            const { TickerSetupPage } = await import('@@routes/ticker');

            return { Component: TickerSetupPage };
        },
    },
    {
        path: ':id',
        lazy: async () => {
            const { TickerDetailPage } = await import('@@routes/ticker');

            return { Component: TickerDetailPage };
        },
        children: [
            {
                index: true,
                lazy: async () => {
                    const { default: TickerContent } =
                        await import('@@routes/ticker/content/TickerContent');

                    return { Component: TickerContent };
                },
                errorElement: <ErrorPage />,
            },
            metadataRoute,
            pushRoute,
        ],
    },
];
